import { useProjectContext } from "@contexts/projects";

export const checkIfMultipleIds = () => {
  const { activeProject } = useProjectContext();
  if (!activeProject) return
  const { wbs_code_ids } = activeProject
  if (!wbs_code_ids) return
  return wbs_code_ids.length > 1
}

export const unitsIntoArray = () => {
  const { activeProject } = useProjectContext();
  if (!activeProject) return
  const { units } = activeProject
  if (!units) return
  return [...new Set(units.map(i => i.wbs_code_id_building))]?.map(i => units.filter(j => j.wbs_code_id_building === i))
}